<template>
  <div class="inside_pages_right">
    <div class="inside_pages_right_top">
      <div class="inside_header_title">公共安全知识库</div>
    </div>
    <div class="inside_pages_right_content">
      <div class="inside_pages_right_content_top ">
        <div class="inside_pages_right_content_top_left ">
          <cate-cascader></cate-cascader>
        </div>
        <div class="inside_pages_right_content_top_right ">
          <el-input
            v-model.trim="requestData.title"
            size="mini"
            placeholder="请输入资源名称"
          ></el-input>
          &nbsp;
          <el-select v-model="requestData.fileClassification" size="mini">
            <el-option label="请选文件分类" value=""> </el-option>
            <el-option
              v-for="item in $store.state.select.knowledgeCategory"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option> </el-select
          >&nbsp;
          <el-button size="mini" type="primary" plain icon="el-icon-search"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="inside_pages_right_content_center">
        <el-table
          :data="responseData.list"
          height="100%"
          border
          style="width: 100%"
        >
          <el-table-column prop="id" label="ID"> </el-table-column>

          <el-table-column prop="name" label="资源名称"> </el-table-column>

          <el-table-column prop="img" label="封面图">
            <template slot-scope="scope">
              <el-image
                class="img-thumbnail"
                :src="$store.state.config.fileUrl + scope.row.img"
                :preview-src-list="[
                  $store.state.config.fileUrl + scope.row.img,
                ]"
              >
              </el-image>
            </template>
          </el-table-column>

          <el-table-column prop="class1" label="所属分类"> </el-table-column>

          <el-table-column prop="class2" label="文件分类"> </el-table-column>

          <el-table-column prop="date" label="发布时间"> </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="mini"
                icon="el-icon-document"
              >
                预览
              </el-button>
              <el-button
                type="primary"
                plain
                size="mini"
                icon="el-icon-data-analysis"
              >
                使用统计
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="inside_pages_right_content_bottom">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="responseData.pageNum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CateCascader from './components/CateCascader'
export default {
  name: '',
  components: {
      CateCascader
  },
  props: {},
  data() {
    return {
      requestData: {
        pageNum: 1,
        pageSize: 20,
        fileClassification: '',
        title: '',
      },
      // 数据列表
      responseData: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        total: 0, // 总条数
        pages: 0, // 总页数
        list: [
          {
            id: 1,
            name: '调整情绪合理应对 改进学习状态',
            date: '2016-05-03',
            img: 'images/20200522/e51881bb28964b748b1677c780036b21.png',
            class1: '疫情防控-疫情防控',
            class2: '读一读',
          },
        ], // 数据列表
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    // 获取数据列表
    async getDataList() {
      let res = await this.$Http.getPublicSafetyKnowledge(
        this.requestData,
        true
      )
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize
        this.responseData.pageNum = res.data.pageNum
        this.responseData.total = res.data.total
        this.responseData.pages = res.data.pages
        this.responseData.list = res.data.list
        // console.log(this.responseData.list)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: 'error',
          message: res.messsage,
        })
      }
    },
  },
  created() {},
  mounted() {
    // this.getDataList()
  },
}
</script>
